<template class="back">
    <el-container>
        <el-header height="380" class="app-header">
            <div class="app-header-top">
                <div class="top-text">
                    <div>
                        <img src="data:image/jpeg;base64,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" style="height: 50px; width: 50px;">
                    </div>
                    <div style="margin-left: 10px">坊间三寻</div>
                </div>
            </div>
            <div class="top-img">
                <template>
                    <el-carousel :interval="5000" height="400px" arrow="always">
                        <el-carousel-item v-for="item in imgList" :key="item">
                            <el-image :src="item" fit="cover" style="height: 100%;width: 100%"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </template>
            </div>

        </el-header>

        <el-container  class="app-container">
            <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
                <el-menu>
                    <el-submenu  v-for="item in nvaList" :key="item.id" :index="item.cat_no">
                        <template slot="title">{{item.title}}</template>
                        <el-menu-item :index="nav.cat_no" v-for="nav in item.list" :key="nav.id" @click="setCategory(nav.id)">
                            {{nav.title}}
                        </el-menu-item>
                    </el-submenu>

                </el-menu>
            </el-aside>

            <el-container>
                <el-main>
                    <div class="goods-container" v-infinite-scroll="load">
                        <div class="refreshStyle" style="width: 19%;" @click="goGoods(item.id)" v-for="item in goodsList" :key="item.id">
                            <div class="el-image" style="width: 100%; height: 230px;">
                                <img :src="item.images" class="el-image__inner">
                            </div>
                            <div data-v-62fd4cda="" style="padding-left: 5px; box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.04) 0px 0px 6px; padding-bottom: 10px;">
                                <div data-v-62fd4cda="" class="goodsName" style="color: rgb(51, 51, 51);">
                                    {{item.title}}
                                </div>
                                <div data-v-62fd4cda="" class="goodsStock">
                                    库存: {{item.stock}}
                                </div>
                                <div data-v-62fd4cda="" style="display: flex; justify-content: space-between;">
                                    <div data-v-62fd4cda="" class="goodsPrice">
                                        价格: {{item.price}}元
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-empty v-show="emptyShow" description="没有数据"></el-empty>
                </el-main>
            </el-container>
        </el-container>
    </el-container>
</template>

<script>

import axios from "axios";


export default {
    data() {
        return {
            imgList:['/banner.png','/banner.png'],
            nvaList:[],
            goodsList:[],
            page:1,
            loading: true,
            cat_id: 0,
            emptyShow:false,
            host:'https://admin.fjsx.net'
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        getInfo(){
            axios.get(this.host + '/home/index/get_cat').then(response => {
                if (response.status !== 200){
                    this.$message({
                        message: '请求失败,请稍后再试!',
                        type: 'warning'
                    });
                }
                console.log(response.data);
                this.nvaList = response.data;
            }).catch(error => {
                console.log(error)
                this.$message({
                    message: '请求失败,请稍后再试!',
                    type: 'warning'
                });
            })
        },

        setCategory(catId){
            this.cat_id = catId;
            this.goodsList = [];
            this.page = 1;
            this.loading = true;
            if (this.emptyShow === true){
                this.load();
            }
        },

        load(){
            let url = this.host + '/home/index/get_goods?page=' + this.page
            if (parseInt(this.cat_id) > 0){
                url = this.host + '/home/index/get_goods?page=' + this.page + '&cat_id=' + this.cat_id
            }
            if (this.loading === false) {
                return false;
            }
            axios.get(url).then(response => {
                if (response.status !== 200){
                    this.$message({
                        message: '请求失败,请稍后再试!',
                        type: 'warning'
                    });
                }
                response.data.forEach((item) => {
                    this.goodsList.push(item)
                });
                if (response.data.length < 20){
                    this.loading = false;
                }else{
                    this.page ++;
                }
                this.emptyShow = this.goodsList.length === 0;
            }).catch(error => {
                this.$message({
                    message: '请求失败,请稍后再试!',
                    type: 'warning'
                });
                console.log(error)
            })
        },
        goGoods(id){
            this.$router.push('/goods?id=' + id);
        }
    }
};
</script>

<style>
.app-container {
    margin: 0 auto;
    height: 100%;
    width: 1500px;
    border: 1px solid #eee
}
.app-header{
    width: 100%;
    margin-top: 0;
    height: 450px;
    .app-header-top{
        width: 100%;
        height: 50px;
        background: #409EFF;
        margin: 0 auto;
        .top-text{
            display: flex;
            margin: auto;
            width: 1500px;
            line-height: 50px;
            font-size: 18px;
            font-weight: 500;
            color: rgb(255, 255, 255);
        }
    }
}

.top-img{
    width: 1500px;
    height: 20px;
    margin: 0 auto;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.goods-container{
    display: flex;
    flex-wrap: wrap; /* 允许项目换行 */
    justify-content: flex-start; /* 对齐方式 */
}
.refreshStyle{
    margin-left: 10px;
    margin-bottom: 10px;
}
.goodsName{
    margin-left: 5px;
    font-size: 15px;
    font-weight: 500;
    line-height: 26px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.goodsStock{
    font-size: 13px;
    margin-left: 5px;
    font-weight: 400;
    color: #999;
    line-height: 30px
}
.goodsPrice{
    font-size: 16px;
    margin-left: 3px;
    color: #f8393e;
    font-weight: 500;
    line-height: 26px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
